import React from 'react'
import { Button, Form, Input } from 'antd';
import Env from '../../../util/env'
import './index.less';

const FormItem = Form.Item;

class Login extends React.Component {

  // constructor(props) {
  //   super (props);
  // }

  handleSubmit = e => {
    e.preventDefault ();

    this.props.form.validateFields ((err, values) => {
      if (!err) {
        const name = values.userName;
        const password = values.password;
        Env.login ({ name, password }, (res) => {
          if (res.error) {
            alert (res.msg || '登录出错')
            return
          }
          this.props.history.push ('/');
        })
      }
    });
  }

  render() {

    const { getFieldDecorator } = this.props.form;
    return (
        <div className="pg-login">
          <div className="pg-login-left">
          </div>
          <div className="pg-login-right">
            <div className="right-mid">
              <div className="pg-login-logo">
                <img src={require ("../../../img/logo-wayzi.png")} alt="logo"/>
                <span>高精地图</span>
              </div>
              <div className="pg-login-form">
                <Form onSubmit={this.handleSubmit} className="login-form">
                  <FormItem>
                    {getFieldDecorator ('userName', {
                      rules: [ { required: true, message: 'Please input your username!' } ],
                    }) (
                        <Input placeholder="请输入账户名" className="pg-login-input"/>
                    )}
                  </FormItem>

                  <FormItem>
                    {getFieldDecorator ('password', {
                      rules: [ { required: true, message: 'Please input your Password!' } ],
                    }) (
                        <Input type="password" placeholder="请输入密码" className="pg-login-input"/>
                    )}
                  </FormItem>

                  <FormItem>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                      登录
                    </Button>
                  </FormItem>
                </Form>
              </div>
            </div>
          </div>
        </div>
    )
  }
}

Login = Form.create () (Login);

export default Login;



// WEBPACK FOOTER //
// ./src/routes/Passport/Login/index.js